export default "__VITE_ASSET__BFWHr4tR__"